import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
export const DownloadLink = ({ fileUrl, fileName }) => {
    const linkRef = useRef(null);
    useEffect(() => {
        if (linkRef.current) {
            linkRef.current.click();
        }
    }, []);
    return (_jsxs("p", { children: [_jsx("a", { ref: linkRef, href: fileUrl, download: fileName, className: 'text-vjwPrimary hover:underline', children: "Click here" }), _jsx("span", { children: " if the file is not downloaded automatically" })] }));
};
